const sizeData = [
  { id: 1, name: "دور سینه", label: "chest_circumference" },
  { id: 2, name: "دور بازو", label: "arm_circumference" },
  { id: 3, name: "دور ناف", label: "stomach_circumference" },
  { id: 4, name: "دور باسن", label: "pelvis_circumference" },
  { id: 5, name: "دور ران", label: "thigh_circumference" },
  { id: 6, name: "دور ساق پا", label: "leg_circumference" },
  { id: 7, name: "وزن", label: "weight" },
];

export default sizeData;
